import React from 'react';
import EmailIcon from '@sls-react/static/svg/EmailIcon';
import classNames from 'classnames';

type Props = React.HTMLProps<HTMLButtonElement> & {
  filled?: boolean;
  text?: string;
};

const EmailLoginButton: React.FC<Props> = ({
  className,
  filled,
  text,
  ...props
}) => (
  <button
    className={classNames(
      'flex items-center justify-center w-full h-10 px-4 text-sm font-semibold text-white bg-primary-500 rounded',
      className,
    )}
    {...props}
    type="button"
  >
    <EmailIcon fill="currentColor" />
    <div className="ml-4">{text || 'Continue with Email'}</div>
  </button>
);

export default EmailLoginButton;
